<template>
  <div style="background: #ffffff;height: 100%;">
    <div id="WangEditor" ref="fixd"></div>
  </div>
</template>

<script>
  import config from '../config/index'
  import WangEditor from 'wangeditor'
  export default {
    data() {
      return {
        strNum:0,
        config: config,
        content: '',
        editor:'',
        stat: 1
      }
    },
    props:{
      contents:{
        type: String,
        default: ''
      },

      yinY: {
        type: Number,
        default: 1
      },
      upActive:{
        type: Boolean,
        default: false
      }
    },
    computed: {

    },
    created(){

    },
    mounted () {
      let that = this
      this.editor = new WangEditor('#WangEditor')  //这个地方传入div元素的id 需要加#号
      this.editor.customConfig.menus = [          // 菜单配置
        'head',  // 标题
        'bold',  // 粗体
        'fontSize',  // 字号
        // 'fontName',  // 字体
        'italic',  // 斜体
        'underline',  // 下划线
        'strikeThrough',  // 删除线
        'foreColor',  // 文字颜色
        'backColor',  // 背景颜色
        'link',  // 插入链接
        'list',  // 列表
        'justify',  // 对齐方式
        // 'quote',  // 引用
        // 'emoticon',  // 表情
        'image',  // 插入图片
        'table',  // 表格
        // 'code',  // 插入代码
        'undo',  // 撤销
        'redo'  // 重复
      ]

      // 配置 onchange 事件
      this.editor.change = function () {          // 这里是change 不是官方文档中的 onchange
        // 编辑区域内容变化时，实时打印出当前内容
        this.content = this.txt.html()
        that.$emit('getData',this.txt.html())
      }
      this.editor.customConfig.uploadImgShowBase64 = true
      this.editor.customConfig.pasteTextHandle = (content) => { //支持粘贴
        return content
      }
      this.editor.create()     // 生成编辑器
      // this.editor.txt.html(this.contents)
      this.content = this.contents
      console.log(this.content)


    },
    methods: {

    },
    watch:{
      contents(){
        this.content = this.contents
        console.log(this.stat)
        if( this.stat === 1){
          this.editor.txt.html(this.contents)
          this.stat = 2
          this.$emit('getData',this.contents)
        }else if(this.upActive){
          this.editor.txt.html(this.contents)
          this.$emit('getData',this.contents)
        }

      },
      statesave(){
        // if(this.statesave){
        //   this.editor.txt.html('')
          this.stat = 1
          // console.log(this.content)
        // }

      },
      yinY(){
        // if(this.yinY){
          this.editor.txt.html(this.content)
          // this.stat = 1
        // }
      }
    }
  }
</script>

<style scoped lang="scss">
  .fixd {
    position: fixed !important;
    width: 700px !important;
    top: 0 !important;
    z-index: 1002 !important;
  }
</style>
